import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import * as en from "./assets/locales/en";
import * as sv from "./assets/locales/sv";

const resources = {
    en: Object.fromEntries(Object.entries(en)),
    sv: Object.fromEntries(Object.entries(sv)),
};

const systemLanguage = navigator.language.split("-")[0];

void i18n.use(initReactI18next).init({
    resources,
    lng: resources[systemLanguage] ? systemLanguage : "en",
    fallbackLng: "en",
    supportedLngs: ["en", "sv"],
    ns: Object.keys(resources.en),
    defaultNS: "common",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18n;
